import {
  HOMEOWNER_ADDON_CONTACT,
  HOMEOWNER_ADDON_MAX,
  addonChoiceLabel,
  addonQuote,
  normalizeAddon,
} from '../shared/planLimits';

const CHOICES = ['none', 'plus', 'max'];

/**
 * None, Plus, or Max. The price and the limit it would set are on the button.
 * Max is the hard cap. More than that is a conversation with support.
 */
export default function HomeownerAddonCard({
  currentAddon,
  seats,
  shared,
  selected,
  disabled,
  colors,
  onSelect,
}) {
  const current = normalizeAddon(currentAddon);
  return (
    <div>
      <h4 style={{ margin: '0 0 0.35rem', color: colors.text }}>Homeowner add-on</h4>
      <p style={{ margin: '0 0 0.75rem', color: colors.textSecondary, fontSize: '0.9rem' }}>
        {shared
          ? 'Billed per seat on your current subscription. The shared pool rises with the add-on.'
          : 'Added to your current subscription. Your billing is prorated when this changes.'}
      </p>
      <div style={{ display: 'grid', gap: '0.75rem' }}>
        {CHOICES.map((id) => {
          const quote = addonQuote({ addon: id, seats, shared });
          const isCurrent = current === id;
          const isSelected = selected === id;
          return (
            <button
              key={id}
              type="button"
              disabled={disabled}
              aria-pressed={isSelected}
              onClick={() => onSelect(id)}
              style={{
                textAlign: 'left',
                border: `2px solid ${isSelected ? '#59c4c4' : colors.border}`,
                borderRadius: '0.75rem',
                padding: '0.9rem 1rem',
                background: isSelected ? (colors.surfaceAlt || 'rgba(89, 196, 196, 0.1)') : 'transparent',
                color: colors.text,
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.6 : 1,
              }}
            >
              <span style={{ display: 'block', fontWeight: 700 }}>
                {addonChoiceLabel(quote)}
                {isCurrent ? ' (current)' : ''}
              </span>
            </button>
          );
        })}
      </div>
      <p style={{ margin: '0.75rem 0 0', color: colors.textSecondary, fontSize: '0.9rem' }}>
        {`Need more than ${HOMEOWNER_ADDON_MAX.toLocaleString('en-US')} homeowners per agent? Contact us at ${HOMEOWNER_ADDON_CONTACT}.`}
      </p>
    </div>
  );
}
